import template   from './manage-purchase-navbar.html'
import controller from './manage-purchase-navbar.controller'
import './manage-purchase-navbar.styl'

let component = {
  restrict: 'E',
  bindings: {
    activeTab: '='
  },
  controller,
  template
}

export default component



// WEBPACK FOOTER //
// ./src/app/pages/manage-purchase/common/manage-purchase-navbar/manage-purchase-navbar.component.js